import { customColorClasses as r, customTextSizes as o } from "../const/__generated__/themeConst.es.js";
import t from "clsx";
import { extendTailwindMerge as n, twMerge as s } from "tailwind-merge";
var c = n({ extend: { classGroups: {
  "font-size": [...o],
  "text-color": [...r]
} } });
function a(...e) {
  return c(e);
}
function l(e) {
  return e.replace(/\u00A0/g, " ");
}
function f(...e) {
  return s(t(e));
}
export {
  a as cn,
  f as cnBase,
  c as merge,
  l as normalizeSpaces
};
